import styled from "styled-components"
import { WrapPopupEdit } from "../index.style"

const WrapPopupEditPassport = styled(WrapPopupEdit)`

`

export {
    WrapPopupEditPassport
}